import { gql } from '@apollo/client';

export default gql`
  query place($id: ID!) {
    space {
      overInspectionsLimit
      adminRole
    }
    place(id: $id) {
      id
      name
      street
      city
      zipCode
      inspectionSubjectsTotal
      inspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      externalFiles {
        id
        filename
        contentType
        fileSize
        externalUrl
        isImage
        isPdf
        fileExtension
      }
    }
  }
`;
